$(function() {

  var dirRtlFlag = false;
  if ($("html").attr('dir') == 'rtl') {
    dirRtlFlag = true;
  }


    $('.gallery-slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 2000,
      autoplay: false,
      autoplaySpeed: 100,
      rtl: dirRtlFlag,
      // rtl: false,
      slidesToShow: 4,
      slidesToScroll: -1,
      prevArrow: $('.gallery-slider__prev'),
      nextArrow: $('.gallery-slider__next'),
        responsive: [
        // {
        //   breakpoint: 1500,
        //   settings: {
        //   slidesToShow: 5,
        //   slidesToScroll: 1,
        //   }
        // },
        {
          breakpoint: 1250,
          settings: {
          slidesToShow: 3,
          slidesToScroll: -1,
          }
        },
        // {
        //   breakpoint: 980,
        //   settings: {
        //   slidesToShow: 3,
        //   slidesToScroll: 1,
        //   }
        // },
        {
          breakpoint: 780,
          settings: {
          slidesToShow: 2,
          slidesToScroll: -1,
          }
        },
        {
          breakpoint: 480,
          settings: {
          slidesToShow: 1,
          slidesToScroll: -1,
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
        ] 
      });


      $('.gallery-slider').lightGallery({
        thumbnail: true,
        animateThumb: false,
        showThumbByDefault: false,
        selector: '.gallery2__block'
      });
});
